import { NgModule } from '@angular/core';
import { ConfigSharedHotelService } from "./config-shared-hotel.service";
import { ConfigurationResourceModule } from "./configurationResource.module";

@NgModule({
    imports: [
        ConfigurationResourceModule,
    ],
    providers: [
        ConfigSharedHotelService,
    ]
})
export class ConfigSharedHotelModule {
}